






























import {
  SfCheckbox,
  SfChevron
} from '~/components';
import { clickOutside } from '~/utilities/directives';
import { computed, defineComponent, onBeforeUnmount, onMounted, ref, watch } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'SizeSelector',
  directives: { clickOutside },
  components: {
    SfCheckbox,
    SfChevron
  },
  props: {
    product: {
      type: Object,
      default: () => {},
      require: true
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'open', 'selected-size'],
  setup(props, { emit }) {

    const selectedSize = ref({
      productUid: '',
      label: '',
      uid: '',
      sku: '',
      saleable_qty: 0
    });

    const computedSizes = computed(() => props.product?.configurable_options?.[0]?.values);

    const handleSize = (size) => {
      selectedSize.value.productUid = props.product.uid;
      selectedSize.value.label = size.label;
      selectedSize.value.uid = size.uid;
      selectedSize.value.sku = size.sku;
      selectedSize.value.saleable_qty = size.saleable_qty;
      emit('selected-size', selectedSize);
    };

    const handleDropdownClick = (event) => {
      const target = event.target;
      if (target.closest('.size-selector__wrap')) {
        if (props.isOpen) {
          emit('close');
        } else {
          emit('open', !props.isOpen);
        }
      }
    };

    const sizeSelector = ref(null);

    const handleDocumentClick = (event) => {
      const target = event.target;

      if (sizeSelector.value && !sizeSelector.value.contains(target)) {
        emit('close');
      }
    };

    onMounted(() => {
      if (computedSizes.value) {
        selectedSize.value.productUid = props.product.uid;
        selectedSize.value.label = computedSizes.value[0]?.label;
        selectedSize.value.uid = computedSizes.value[0]?.uid;
        selectedSize.value.sku = computedSizes.value[0]?.sku;
        selectedSize.value.saleable_qty = computedSizes.value[0]?.saleable_qty;
        emit('selected-size', selectedSize);
      }

      document.addEventListener('click', handleDocumentClick);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleDocumentClick);
    });

    return {
      sizeSelector,
      computedSizes,
      selectedSize,
      handleDropdownClick,
      handleSize
    };
  },
});
